import React, { useEffect, useState } from "react";
import axios from "axios";
import "./RegistrationForm.css";
import { runnersOptions } from "../../utils/runnersOptions";

const API_URL = process.env.REACT_APP_BACKEND_API_URL;

// ================= DEADLINE =================
const deadline = new Date("2026-05-21T23:59:59"); // change when needed

function RegistrationForm() {
  const runnerTypes = runnersOptions();

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    runnerType: "",
    email: "",
    phone: "",
    organisation: "",
    editionName: "",
  });

  const [currentEdition, setCurrentEdition] = useState("");
  const [loading, setLoading] = useState(false);
  const [loadingEdition, setLoadingEdition] = useState(true);
  const [message, setMessage] = useState("");

  const [showSuccess, setShowSuccess] = useState(false);

  // ================= CLOSED STATE =================
  const [isClosed, setIsClosed] = useState(new Date() > deadline);

  useEffect(() => {
    const fetchCurrentEdition = async () => {
      setLoadingEdition(true);

      try {
        const response = await axios.get(
          `${API_URL}/ripplerun-editions/current`
        );

        const editionName = response.data?.editionName || "";

        if (editionName) {
          setCurrentEdition(editionName);
          setFormData((prev) => ({ ...prev, editionName }));
        } else {
          setCurrentEdition("");
        }
      } catch (error) {
        console.error("Error fetching current edition:", error);
        setCurrentEdition("");
      } finally {
        setLoadingEdition(false);
      }
    };

    fetchCurrentEdition();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // ================= SUBMIT =================
  const handleSubmit = async (e) => {
    e.preventDefault();

    // 🔥 BLOCK IF CLOSED
    if (new Date() > deadline) {
      setIsClosed(true);
      return;
    }

    if (!currentEdition) {
      setMessage("No active edition available.");
      return;
    }

    setLoading(true);
    setMessage("");

    try {
      const payload = {
        ...formData,
        createdBy: "Website",
      };

      await axios.post(`${API_URL}/registrations`, payload);

      setShowSuccess(true);

      setFormData({
        firstName: "",
        lastName: "",
        runnerType: "",
        email: "",
        phone: "",
        organisation: "",
        editionName: currentEdition,
      });

      setTimeout(() => {
        setShowSuccess(false);
      }, 3000);
    } catch (error) {
      setMessage(
        error.response?.data?.message ||
          "Registration failed. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="registration" id="registration-section">

      <div className="registration-container">

        {/* LEFT CONTENT */}
        <div className="registration-text">
          <h2>Join the Movement!</h2>
          <p>
            Earth is ~71% water.<br /><br />
            Humans are ~60% water.<br /><br />
            We are walking reflections of the planet.<br /><br />
            Protecting water is protecting ourselves.
          </p>
        </div>

        {/* FORM CARD */}
        <div className="registration-form-card">

          {/* ================= CLOSED STATE BANNER ================= */}
          {isClosed && (
            <div className="registration-closed-banner">
              <h2>Registration Closed</h2>
               <h2>Next Edition Coming Soon...</h2>
               <p>Stay tuned for the next Ripple Run experience.</p>
            </div>
          )}

          {!isClosed && (
            <form className="registration-form" onSubmit={handleSubmit}>
              <div className="form-grid">

                <div className="form-group">
                  <label>First Name *</label>
                  <input
                    type="text"
                    name="firstName"
                    value={formData.firstName}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="form-group">
                  <label>Last Name *</label>
                  <input
                    type="text"
                    name="lastName"
                    value={formData.lastName}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="form-group full">
                  <label>Type of Runner *</label>
                  <select
                    name="runnerType"
                    value={formData.runnerType}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Select Runner Type</option>
                    {runnerTypes.map((type, index) => (
                      <option key={index} value={type}>
                        {type}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="form-group full">
                  <label>Email *</label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="form-group full">
                  <label>Phone *</label>
                  <input
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="form-group full">
                  <label>Organisation *</label>
                  <input
                    type="text"
                    name="organisation"
                    value={formData.organisation}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="form-group full">
                  <label>Edition</label>
                  <input
                    type="text"
                    value={
                      loadingEdition
                        ? "Fetching edition..."
                        : currentEdition
                    }
                    disabled
                  />
                </div>
              </div>

              {message && <p className="form-message">{message}</p>}

              <button
                type="submit"
                className="register-btn"
                disabled={loading || loadingEdition || isClosed || !currentEdition}
              >
                {loading
                  ? "Registering..."
                  : isClosed
                  ? "Registration Closed"
                  : "Register Now"}
              </button>
            </form>
          )}
        </div>

      </div>

      {/* SUCCESS OVERLAY */}
      {showSuccess && (
        <div className="success-overlay">
          <div className="success-card">
            <div className="checkmark-circle">
              <div className="checkmark"></div>
            </div>
            <h2>Registration Successful</h2>
            <p>You will receive an SMS shortly.</p>
          </div>
        </div>
      )}

    </section>
  );
}

export default RegistrationForm;